import React from "react";
import DraftsIcon from "@mui/icons-material/Drafts";
import DomainAddOutlinedIcon from "@mui/icons-material/DomainAddOutlined";
import { Tooltip } from "@mui/material";
import { GmailIcon } from "./gmailIcon";
import { MicrosoftIcon } from "./microsoftIcon";

const SMTP_PROVIDER_MAP = [
  { match: "smtp.resend.com", name: "Resend", isResend: true },
  { match: "smtp.sendgrid.net", name: "SendGrid", abbr: "SG", color: "#1A82E2" },
  { match: "smtp.postmarkapp.com", name: "Postmark", abbr: "PM", color: "#FFDE00", textColor: "#333" },
  { match: "smtp.mailgun.org", name: "Mailgun", abbr: "MG", color: "#F06B66" },
  { match: "email-smtp", name: "AWS SES", abbr: "SES", color: "#FF9900" },
  { match: "smtp.sparkpostmail.com", name: "SparkPost", abbr: "SP", color: "#FA6423" },
  { match: "smtp.zoho.com", name: "Zoho Mail", abbr: "ZM", color: "#E42527" },
  { match: "smtp.office365.com", name: "Office 365", abbr: "365", color: "#0078D4" },
  { match: "smtp.gmail.com", name: "Gmail (SMTP)", isGoogle: true },
  { match: "smtp-relay.gmail.com", name: "Gmail Relay", isGoogle: true },
];

function getSmtpProvider(smtpHost) {
  if (!smtpHost) return null;
  const host = smtpHost.toLowerCase();
  return SMTP_PROVIDER_MAP.find((p) => host.includes(p.match)) || null;
}

export function MailboxProviderIcon({ mailbox, size = "20px" }) {
  const provider = mailbox?.provider;
  const smtpHost = mailbox?.config?.smtp?.host;
  const sizePx = typeof size === "number" ? `${size}px` : size;

  if (provider === "google") {
    return (
      <Tooltip title="Gmail">
        <span style={{ display: "flex" }}>
          <GmailIcon size={sizePx} />
        </span>
      </Tooltip>
    );
  }

  if (provider === "microsoft") {
    return (
      <Tooltip title="Microsoft">
        <span style={{ display: "flex" }}>
          <MicrosoftIcon size={sizePx} />
        </span>
      </Tooltip>
    );
  }

  const smtpProvider = getSmtpProvider(smtpHost);
  if (smtpProvider) {
    if (smtpProvider.isGoogle) {
      return (
        <Tooltip title={smtpProvider.name}>
          <span style={{ display: "flex" }}>
            <GmailIcon size={sizePx} />
          </span>
        </Tooltip>
      );
    }
    if (smtpProvider.isResend) {
      return (
        <Tooltip title="Resend">
          <DomainAddOutlinedIcon style={{ fontSize: sizePx }} />
        </Tooltip>
      );
    }
    const sizeNum = parseInt(sizePx, 10) || 20;
    return (
      <Tooltip title={smtpProvider.name}>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: sizeNum,
            height: sizeNum,
            borderRadius: 3,
            backgroundColor: smtpProvider.color,
            color: smtpProvider.textColor || "#fff",
            fontSize: Math.max(6, Math.floor(sizeNum * 0.38)),
            fontWeight: 700,
            flexShrink: 0,
            letterSpacing: "-0.3px",
            lineHeight: 1,
          }}
        >
          {smtpProvider.abbr}
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={smtpHost ? `Custom SMTP (${smtpHost})` : "Custom SMTP"}>
      <DraftsIcon style={{ fontSize: sizePx }} color="primary" />
    </Tooltip>
  );
}
